import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-forgot-password-page',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './forgot-password.page.html',
  styleUrl: './forgot-password.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ForgotPasswordPageComponent {
  email = '';
  message = '';
  errorMessage = '';
  isLoading = false;

  constructor(
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  submit(): void {
    if (!this.email) {
      this.errorMessage = 'Veuillez saisir votre email.';
      return;
    }
    this.errorMessage = '';
    this.message = '';
    this.isLoading = true;
    this.authService.requestPasswordReset(this.email).subscribe({
      next: () => {
        this.isLoading = false;
        this.message = 'Si un compte existe, un email de réinitialisation a été envoyé.';
        this.cdr.markForCheck();
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'Impossible d’envoyer la demande. Réessayez plus tard.';
        this.cdr.markForCheck();
      }
    });
  }
}
